module.exports = __webpack_public_path__ + "img/landing-anim.717842f2.gif";